import { render } from "./DailyBlock.vue?vue&type=template&id=fccf36f2"
import script from "./DailyBlock.vue?vue&type=script&lang=js"
export * from "./DailyBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__